import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IMAGES } from '../layout/theme';

interface TeamMember {
    image: string;
    title: string;
    subtitle: string;
    flag: string[];
}

const TeamSection: React.FC = () => {
    const { t } = useTranslation();

    const teamData: TeamMember[] = [
        { image: IMAGES.anaAvatar, title: t('teamSection.ana'), subtitle: t('teamSection.anaSub'), flag : [ "🇪🇸","🇬🇧", "🇵🇹"] },
        { image: IMAGES.pedroAvatar, title: t('teamSection.pedro'), subtitle: t('teamSection.pedroSub'), flag : ["🇬🇧", "🇪🇸", "🇵🇹"] },
        { image: IMAGES.marcoAvatar, title: t('teamSection.marco'), subtitle: t('teamSection.marcoSub'), flag : ["🇫🇷", "🇪🇸", "🇵🇹"] },
    ];

    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="center-title">
                        <span className="sub-title">{t('teamSection.subtitle')}</span>
                        <h2 className="h2-title">{t('teamSection.title')}</h2>
                    </div>
                </div>
            </div>
            <div className="main-team-list" style={{ marginTop: '40px' }}>
                <div className="row page-team-slider">
                    {teamData.map((item, i) => (
                        <div className="col-lg-4" key={i}>
                            <div className="team-box">
                                <div className="team-img-box">
                                    <div className="team-img back-img" style={{ backgroundImage: `url(${item.image})` }}></div>
                                    <div className="team-social">
                                        {item.flag.map((flag, index) => (
                                            <Link to="#" className="team-social-link" key={index}>{flag}</Link>
                                        ))}
                                    </div>
                                </div>
                                <div className="team-text">
                                    <h3 className="h3-title">{item.title}</h3>
                                    <p>{item.subtitle}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TeamSection;